import { LivechatEnablerBlock } from './LivechatEnablerBlock'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  activeBot: state.activeBot,
})

export default connect(mapStateToProps)(LivechatEnablerBlock)
